import { ContactRelationshipsTable } from './ContactRelationshipsTable';
import { ContactHouseholdChart } from 'assets/js/pages/contacts/ContactHouseholdChart';
import { ContactHouseholdTable } from 'assets/js/pages/contacts/ContactHouseholdTable';
import { useHouseholdId } from 'customHooks/useCurrentContactHousehold';

const ContactRelationships = () => {
    const householdId = useHouseholdId();

    return (
        <div className="flex flex-col gap-4">
            <ContactRelationshipsTable />
            <ContactHouseholdTable />
            {!!householdId && <ContactHouseholdChart />}
        </div>
    );
};

export { ContactRelationships };
